module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_6005.56fd93a0.png";